<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <img v-if="image" :src="image" class="circular--square" width="30px" height="30px" alt="user_image" />
      <img v-else src="../assets/user.png" class="img-avatar" alt="admin@wti.org.in" />
      <span class="pr-4 pl-1"><b>{{ username }}</b><i class="fa fa-dropdown" style="color:black!important"></i></span>
    </template>\
    <template slot="dropdown">
      <!-- <b-dropdown-header tag="div" class="text-center"><strong>Account</strong></b-dropdown-header>
      <b-dropdown-item><i class="fa fa-bell-o" /> Updates
        <b-badge variant="info">{{ itemsCount }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-item><i class="fa fa-envelope-o" /> Messages
        <b-badge variant="success">{{ itemsCount }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-item><i class="fa fa-tasks" /> Tasks
        <b-badge variant="danger">{{ itemsCount }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-item><i class="fa fa-comments" /> Comments
        <b-badge variant="warning">{{ itemsCount }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-header
        tag="div"
        class="text-center">
        <strong>Settings</strong>
      </b-dropdown-header>
      <b-dropdown-item><i class="fa fa-user" /> Profile</b-dropdown-item>
      <b-dropdown-item><i class="fa fa-wrench" /> Settings</b-dropdown-item>
      <b-dropdown-item><i class="fa fa-usd" /> Payments
        <b-badge variant="secondary">{{ itemsCount }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-item><i class="fa fa-file" /> Projects
        <b-badge variant="primary">{{ itemsCount }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-divider />
      <b-dropdown-item><i class="fa fa-shield" /> Lock Account</b-dropdown-item> -->
      <b-dropdown-item @click="profile()"><i class="fa fa-eye" /> profile</b-dropdown-item>
      <b-dropdown-item v-b-modal.modal-footer-sm1><i class="fa fa-lock" /> Change Password</b-dropdown-item>
      <b-dropdown-item @click="logout()"><i class="fa fa-sign-out"></i>Logout</b-dropdown-item>
      <b-modal id="modal-footer-sm1" title button-size="sm">
        <form @submit="onsubmit1">
          <h4 style="font-size:20px!important">Change My Password</h4>
          <div class="pb-3 pt-3">
            <label>Old Password</label>
            <input v-model="oldpassword" type="password" required class="pt-2 pb-2"
              style="color:black!important;width:100%!important;">
            <!-- <span toggle="#password-field" class="fa fa-fw fa-eye field-icon toggle-password"></span> -->
          </div>

          <div class="pb-3">
            <label>New Password</label>
            <input v-model="password" type="password" required class="pt-2 pb-2"
              style="color:black!important;width:100%!important;" />
          </div>
          <div class="d-flex justify--center mt-3">
            <button type="submit" class=" pt-2 pb-2 btn btn-success" style="width:100%!important;">Submit</button>
          </div>

        </form>
      </b-modal>

    </template>
  </AppHeaderDropdown>
</template>

<script>
import axios from 'axios'
import store from '../store'
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return {
      itemsCount: 42,
      username: localStorage.getItem('username'),
      image: '',
      oldpassword: '',
      password: '',
      id: localStorage.getItem('ownerid'),
    }
  },
  mounted: function () {
    this.getview()
  },
  methods: {
    logout() {

      localStorage.removeItem('token')
      localStorage.removeItem('username')
      localStorage.removeItem('is_admin')
      localStorage.removeItem('id')
      store.commit('logoutUser')
      this.$router.push({ name: 'Login' })

    },
    changepass() {
      this.$router.push({ path: "/a" });
    },
    profile() {
      this.$router.push({ path: "/myprofile" });
    },
    getview() {
      this.visible = true
      axios({
        method: 'GET',
        url: '/user/profile',
        params: { 'token': localStorage.getItem('token') }
      })
        .then(response => {
          if (response.data.status === true) {

            if (response.data.data.photo != null) {
              this.image = imageURL + response.data.data.photo
            }

            this.visible = false
          } else if (response.data.status === false) {
            this.visible = false
          }
        })
        .catch(err => {
          this.errors.push(err)
          alert('No Network Found!!')
        })
    },
    onsubmit1(evt) {
      this.visible = true

      var data = {}

      data['oldpassword'] = this.oldpassword
      data['password'] = this.password
      data['id'] = this.id
      data['x-auth-token'] = localStorage.getItem("token")

      evt.preventDefault()
      axios({
        method: 'post',
        url: '/user/adminedit',
        data: data,

      })
        .then(response => {
          this.visible = false
          this.status = response.data.status
          this.msg = response.data.msg
          if (response.data.status === true) {
            alert('Password Changed Successfully')
          } else {
            alert('Please Try Again')
          }
        })
        .catch(err => {
          if (err.response.data.status === false) { this.msg = 'Please Try Again' }
        })
    },
  },
};
</script>

<style>
.card-body>>>table>tbody>tr>td {
  cursor: pointer;
}

.btn.btn-sm,
.btn-group-sm>.btn {
  display: none !important;
}

.circular--square {
  border-top-left-radius: 50% 50%;
  border-top-right-radius: 50% 50%;
  border-bottom-right-radius: 50% 50%;
  border-bottom-left-radius: 50% 50%;
}
</style>
